import { Component, effect, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HeadMetaComponent } from '@app/components/ui.component';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '@app/services/auth.service';
import { ToastService } from '@app/services/toast.service';
import { ToastComponent } from "@app/components/toast/toast.component";
import { AuthError } from '@app/interfaces/auth-models.interface';
import { environment } from '@env/environment';
import { mergeMap, Observable, tap } from 'rxjs';
import { LetDirective } from '@ngrx/component';
import { UserHelperService } from '@app/services/helpers/user-helper.service';

@Component({
    selector: 'app-verify',
    templateUrl: './page.component.html',
    styleUrl: './page.component.scss',
    imports: [
        HeadMetaComponent,
        ReactiveFormsModule,
        ToastComponent,
        CommonModule,
        LetDirective,
    ]
})
export class VerifyComponent {
  messageToast = viewChild<ToastComponent>('messageToast');
  tokenValid$: Observable<boolean>;
  tokenNotExpired$: Observable<boolean>;
  queryString?: string;
  
  constructor(
    private auth: AuthService,
    private toast: ToastService,
    private router: Router,
    private route: ActivatedRoute,
    private userHelper: UserHelperService,
  ) {
    let params = this.route.queryParamMap.pipe(tap((map) => {
      this.queryString = map.keys.map((k) => {
        return k + '=' + map.get(k);
      }).join('&');
    }));
    this.tokenValid$ = params
    .pipe(mergeMap((params) => {
      return this.userHelper.verifyToken(params.get('token') ?? '')
    }))
    this.tokenNotExpired$ = params
    .pipe(mergeMap((params) => {
      return this.userHelper.tokenNotExpired(params.get('token') ?? '', params.get('type') ?? '')
    }));
    effect(() => {
      this.toast.init(this.messageToast());
    })
  }

  navToVerify() {
    let authUrl = environment.authUrl + '/verify?' + this.queryString
    console.log(authUrl)
    window.location.href = authUrl;
  }

}
